import React, { useState, useContext, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/styles";
import {
  Grid,
  Typography,
  Card,
  Tabs,
  Tab,
  Box,
  Button,
} from "@material-ui/core";
import HowtoUse from "./HowtoUse";
// import PremiumAPI from "../serviceslide/premiumAPI";
import { LangContext } from "../../../Context/Langcontext";
import useReactRouter from "use-react-router";
import ResizeDetector from "react-resize-detector";
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

const StyledTabs = withStyles({
  indicator: {
    backgroundColor: "#E16733",
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const useStyle = makeStyles((theme) => ({
  root: { height: "100%", width: "100%", backgroundColor: "#FFFFFF" },
  cardStyle: {
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    margin: "2rem",
    width: "100%",
    maxWidth: "85%",
  },
  maintext: {
    fontSize: "2rem",
    fontWeight: 700,
    textAlign: "center",
    color: "#595A5A",
  },
  secondtexT: {
    fontSize: "1rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
    maxWidth: 860,
  },
  rightcomp: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tabtext: {
    fontSize: "1rem",
    fontFamily: "Kanit",
    textTransform: "unset",
  },
  leftcomp: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  datacomp: {
    // width: "100%",
    // maxHeight: "85%",
    display: "flex",
    // alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  servicebtn: {
    textTransform: "unset",
    color: "#E16733",
    fontSize: "1rem",
    fontWeight: 400,
    borderRadius: 25,
  },
  images: {
    [theme.breakpoints.down("sm")]: {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    },
    [theme.breakpoints.up("md")]: {
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
    },
  },
  images2: {
    [theme.breakpoints.down("sm")]: {
      borderRadius: 8,
    },
    [theme.breakpoints.up("md")]: {
      borderRadius: 8,
    },
  },
}));

const OurApi = ({ children, type, setType }) => {
  const [value, setValue] = useState(0);
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { history, location } = useReactRouter();

  const TabPanel = (props) => {
    const { value, index, name, ...other } = props;

    return (
      <ResizeDetector handleWidth handleHeight>
        {({ width, height }) => (
          <div
            className={classes.datacomp}
            style={{
              display: value !== index ? "none" : "flex",
              height: value === 0 ? 298.171875 : 298.171875,
            }}
          >
            <Typography
              component="div"
              role="tabpanel"
              hidden={value !== index}
              id={`simple-tabpanel-${index}`}
              aria-labelledby={`simple-tab-${index}`}
              {...other}
            >
              {value === index && (
                <Box
                  p={3}
                  style={{
                    color: "#595A5A",
                    fontWeight: 200,
                    // maxWidth: "85%",
                    fontSize: "1rem",
                    // paddingBottom: "6rem",
                  }}
                >
                  {props.children}
                </Box>
              )}
            </Typography>
            <div />
            {value === index && children === undefined ? (
              <div
                style={{
                  width: "90%",
                  textAlign: "right",
                }}
              >
                <Button
                  className={classes.servicebtn}
                  onClick={() => {
                    history.push(`/home/service/#${name}`);
                    window.scrollTo(0, 0);
                  }}
                >
                  {`${lang.Service} >>`}
                </Button>
              </div>
            ) : null}
          </div>
        )}
      </ResizeDetector>
    );
  };

  const handleChange = (event, newValue) => {
    if (children !== undefined) {
      setType(newValue);
      setValue(newValue);
      let a = document.createElement("a");
      a.href = `#${newValue === 0 ? "data" : "map"}`;
      a.click();
    } else {
      setValue(newValue);
      let a = document.createElement("a");
      a.href = `#${newValue === 0 ? "data" : "map"}`;
      a.click();
    }
  };

  useEffect(() => {
    if (location.hash === "#data") {
      setValue(0);
    } else if (location.hash === "#map") {
      setValue(1);
    }
  }, [location]);
  return (
    <Grid container spacing={0} className={classes.root}>
      <Grid
        item
        xs={12}
        style={{
          height: "100%",
          width: "100%",
        }}
      >
        {children !== undefined ? null : (
          <div style={{ textAlign: "center", paddingTop: "2rem" }}>
            <Typography className={classes.maintext}>{lang.OurApi}</Typography>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                paddingTop: "1rem",
              }}
            >
              <Typography className={classes.secondtexT}>
                {lang.SubtitlesOurAPI}
              </Typography>
            </div>
          </div>
        )}

        <div className={classes.leftcomp}>
          <Card className={classes.cardStyle}>
            <div
            // style={{
            //   padding: "2rem",
            // }}
            >
              <Grid container spacing={0}>
                <Grid
                  lg={6}
                  md={12}
                  sm={12}
                  xs={12}
                  item
                  style={{ padding: "2rem 0rem 2rem 2rem" }}
                >
                  <StyledTabs
                    value={value}
                    onChange={handleChange}
                    aria-label="simple tabs example"
                    style={{ color: "#E16733" }}
                  >
                    <Tab
                      label={lang.DataService}
                      id={"dataservice"}
                      className={classes.tabtext}
                    />
                    <Tab
                      label={lang.MapService}
                      id={"mapservice"}
                      className={classes.tabtext}
                    />
                  </StyledTabs>

                  <TabPanel value={value} index={0} name="data">
                    {lang.SubtitlesDataService}
                  </TabPanel>
                  <TabPanel value={value} index={1} name="map">
                    {lang.SubtitlesMapService}
                  </TabPanel>
                </Grid>
                <Grid
                  lg={6}
                  md={12}
                  sm={12}
                  xs={12}
                  item
                  style={{
                    padding: children === undefined ? 0 : "2rem 2rem 0rem 2rem",
                  }}
                >
                  <div className={classes.rightcomp}>
                    {value === 0 ? (
                      <img
                        alt="api_data"
                        className={
                          children === undefined
                            ? classes.images
                            : classes.images2
                        }
                        src={require("../../../images/graphic-icon/data_api-01.png")}
                        style={{
                          width: "100%",
                          height: "auto",
                          maxHeight: 420,
                          // borderTopRightRadius: 8,
                          // borderBottomRightRadius: 8,
                        }}
                      />
                    ) : (
                      <img
                        alt="api_map"
                        className={
                          children === undefined
                            ? classes.images
                            : classes.images2
                        }
                        src={require("../../../images/graphic-icon/map_api.png")}
                        style={{
                          width: "100%",
                          height: "auto",
                          maxHeight: 420,
                          // borderTopRightRadius: 8,
                          // borderBottomRightRadius: 8,
                        }}
                      />
                    )}
                  </div>
                </Grid>
              </Grid>
            </div>
            <main>{children}</main>
          </Card>
        </div>

        {/* {children === undefined ? null : <PremiumAPI />} */}
        <HowtoUse />
      </Grid>
    </Grid>
  );
};

export default OurApi;
